export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8897.d054c574.jpg";